export default {
  setIpadDeviceWidth() {
    var deviceWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if (this.isIpad()) {
      if (deviceWidth * 2 > 750) {
        document.getElementsByTagName('html')[0].style.cssText = 'font-size: 50px';
      }
    }
  },
  // 获取当前相对路径
  GetUrlRelativePath() {
    var url = document.location.toString();
    var arrUrl = url.split("//");

    var start = arrUrl[1].indexOf("/");

    //stop省略，截取从start开始到结尾的所有字符
    var relUrl = arrUrl[1].substring(start);

    if (relUrl.indexOf("?") != -1) {
      relUrl = relUrl.split("?")[0];
    }
    return relUrl;
  },

  // 获取文件扩展名
  getFileExtension(filename) {
    return filename.slice((filename.lastIndexOf(".") - 1 >>> 0) + 2);
  },

  // 常用正则
  regTest: {
    testID: /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/,
    testMobile: /^1[3456789]\d{9}$/,
  },

  // 获取URL参数值
  getParam(name) {
    var search = document.location.search;
    var pattern = new RegExp("[?&]" + name + "\=([^&]+)", "g");
    var matcher = pattern.exec(search);
    var items = null;
    if (null != matcher) {
      try {
        items = decodeURIComponent(decodeURIComponent(matcher[1]));
      } catch (e) {
        try {
          items = decodeURIComponent(matcher[1]);
        } catch (e) {
          items = matcher[1];
        }
      }
    }
    return items;
  },

  // 错误提示
  toggleWarnMsgHttpStatus(msg) {
    var el = document.querySelector('.warn-msg-box');

    el.setAttribute('data-st', '1');
    el.innerHTML = msg;

    setTimeout(() => {
      el.removeAttribute('data-st');
      el.innerHTML = '';
    }, 1000);
  },
  toggleWarnMsg(msg) {
    MINT.Toast({
      message: msg,
      position: 'middle',
      duration: 1000
    });
  },
  closeWarnMsg() {
    var el = document.querySelector('.warn-msg-box');
    el.removeAttribute('data-st');
    el.innerHTML = '';
  },

  // 禁止移动端图片点击预览
  unImgTouch() {
    var el = document.querySelectorAll('.unImgTouch');
    el.forEach(item => {
      item.addEventListener('click', e => {
        e.preventDefault()
      })
    })
  },

  /**
   * @param fn     Function  实际要执行的函数
   * @param delay  Number    延迟时间，也就是阈值，单位是毫秒（ms）
   * @return       Function  返回一个“去弹跳”了的函数
   */
  debounce(fn, delay) {
    var timer;

    // 返回一个函数，这个函数会在一个时间区间结束后的 delay 毫秒时执行 fn 函数
    return function() {

      // 保存函数调用时的上下文和参数，传递给 fn
      var context = this;
      var args = arguments;

      // 每次这个返回的函数被调用，就清除定时器，以保证不执行 fn
      clearTimeout(timer);

      // 当返回的函数被最后一次调用后（也就是用户停止了某个连续的操作），
      // 再过 delay 毫秒就执行 fn
      timer = setTimeout(function() {
        fn.apply(context, args)
      }, delay)
    }
  },

  // 当用户设备宽度小于750px时，强制根标签的font-size为37.5px
  setDeviceWidth() {
    var deviceWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if (deviceWidth * 2 < 750) {
      document.getElementsByTagName('html')[0].style.cssText = 'font-size: 37.5px';
    }
  },

  // 将阿拉伯数字转换成中文数字 垃圾微信浏览器不支持
  // toLocaleStr(num) {
  //   return (num*1.).toLocaleString('zh-hans-CN-u-nu-hanidec', {userGrouping: false})
  // },

  toLocaleStr(num) {
    num = num * 1;
    if (num < 10) {
      switch (num) {
        case 1:
          return '一';
          break;
        case 2:
          return '二';
          break;
        case 3:
          return '三';
          break;
        case 4:
          return '四';
          break;
        case 5:
          return '五';
          break;
        case 6:
          return '六';
          break;
        case 7:
          return '七';
          break;
        case 8:
          return '八';
          break;
        case 9:
          return '九';
          break;
        default:
          break;
      }
    } else {
      switch (num) {
        case 10:
          return '十'
          break;
        case 11:
          return '十一'
          break;
        case 12:
          return '十二'
          break;
        case 13:
          return '十三'
          break;
        case 14:
          return '十四'
          break;
        case 15:
          return '十五'
          break;
        case 16:
          return '十六'
          break;
        default:
          break;
      }
    }
  },

  // 数组随机乱序 时间复杂度 O(n)
  // 支持最多两个类数组参数
  shuffle() {
    var len = arguments[0].length;
    for (var i = 0; i < len - 1; i++) {
      var index = parseInt(Math.random() * (len - i));

      var temp = arguments[0][index];
      arguments[0][index] = arguments[0][len - i - 1];
      arguments[0][len - i - 1] = temp;
      if (arguments.length === 2) {
        var temp = arguments[1][index];
        arguments[1][index] = arguments[1][len - i - 1];
        arguments[1][len - i - 1] = temp;
      }
    }
  },
  GetUserInfo() {
    var userStr = localStorage.getItem('user_info');
    if (!userStr) {
      return null;
    }
    return JSON.parse(userStr);
  },
  GetUserId() {
    var user = this.GetUserInfo();
    if (user) {
      return user.student.id;
    }
  },
  GetUserName() {
    var user = this.GetUserInfo();
    if (user) {
      return user.student.name;
    }
  },
  GetUserToken() {
    var user = this.GetUserInfo();
    if (user) {
      return user.token;
    }
  },
  GetUserUUid() {
    var user = this.GetUserInfo();
    if (user) {
      return user.uid;
    }
  },
  GetUserOpenId() {
    var user = this.GetUserInfo();
    if (user) {
      if (user.student && user.student.open_id) {
        localStorage.setItem('openid',user.student.open_id)
        return user.student.open_id;
      }
      if(user.openId){
        localStorage.setItem('openid',user.openId)
        return user.openId;
      }
    }
    if(sessionStorage.getItem("openid")){
      return sessionStorage.getItem("openid");
    }
    return localStorage.getItem("openid");
  },
  GetJsCodeOpenId(){
    var open_id = localStorage.getItem('jscode_openid');
    if(!open_id){
      open_id = this.GetUserOpenId()
    }
    return open_id;
  },
  GetUserUnionid() {
    var user = this.GetUserInfo();
    if (user) {
      if (user.student && user.student.union_id) {
        localStorage.setItem('unionid',user.student.union_id)
        return user.student.union_id;
      }
      if(user.unionId){
        localStorage.setItem('unionid',user.unionId)
        return user.unionId;
      }
    }

    if(sessionStorage.getItem("unionid")){
      return sessionStorage.getItem("unionid");
    }
    return localStorage.getItem("unionid");
  },
  GetHeaders() {
    return {
      'source': this.GetHeaderSource(),
      'version': this.GetHeaderVersion(),
      'uid': this.GetUserUUid(),
      'token': this.GetUserToken(),
      'user_id': this.GetUserId(),
      'contentType': 'application/json'
    }
  },
  IsIos() {
    var source = this.GetHeaderSource();
    if (source == 'iPad' || source == 'iPhone') {
      return true;
    }
    return false;
  },
  IsAndroid() {
    var source = this.GetHeaderSource();
    if (source == 'Android') {
      return true;
    }
    return false;
  },
  //source 来源
  GetHeaderSource() {
    var source = 'WX';
    if (localStorage.getItem('source')) {
      source = localStorage.getItem('source');
    }
    return source;
  },
  //当前版本
  GetHeaderVersion() {
    var self = this;
    // var version = '';
    // if(self.GetHeaderSource() == 'WX' || self.GetHeaderSource() == 'WAP'){
    //   version = '2.0.0.0';
    // }
    var version = '2.0.0.0';
    if (localStorage.getItem('version') && !(self.GetHeaderSource() == 'WX' || self.GetHeaderSource() == 'WAP')) {
      version = localStorage.getItem('version');
    }
    return version;
  },
  //通知客户端
  CallNative(data) {
    var bridge = dsBridge;
    bridge.call("userLogin", data);
  },
  //是否通知客户端 同步
  CallNativeNotify(mobileMethod, data) {
    var bridge = dsBridge;
    var returnDate = '0';
    // if(KZ.IsAndroid()){
    //   alert("执行了"+mobileMethod+"---"+data.cname+"---"+data.navShow)
    // }
    // alert("执行了"+mobileMethod+"---"+data.cname)
    returnDate = bridge.call(mobileMethod, data);
    return returnDate;
  },
  //检查app是否存在某个方法
  hasNativeMethod(mobileMethod) {
    return dsBridge.hasNativeMethod(mobileMethod);
  },
  //判断是否是微信浏览器
  isWeiXin() {
    var ua = window.navigator.userAgent.toLowerCase();
    //mozilla/5.0 (iphone; cpu iphone os 9_1 like mac os x) applewebkit/601.1.46 (khtml, like gecko)version/9.0 mobile/13b143 safari/601.1
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true;
    } else {
      //如果不是微信浏览器，而且source 还是默认的WX，则修改为WAP
      if (this.GetHeaderSource() == 'WX') {
        localStorage.setItem('source', 'WAP')
      }
      return false;
    }
  },
  //判断移动端是安卓true IOS为false
  isAndroidOrIos() {
    var u = navigator.userAgent;
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
      return false;
    } else if (/(Android)/i.test(navigator.userAgent)) { //判断Android
      return true
    }
  },
  isIpad() {
    var ua = navigator.userAgent;
    if (/iPad/ig.test(ua)) { //判断iPhone|iPad|iPod|iOS
      return true;
    } else {
       return false;
    }
  },
  GetReferrerPath () {
    let url = document.referrer.toString();
    if(!url){
      return '';
    }
    let arrUrl = url.split("//");

    let start = arrUrl[1].indexOf("/");

    //stop省略，截取从start开始到结尾的所有字符
    let relUrl = arrUrl[1].substring(start);

    if(relUrl.indexOf("?") != -1){
      relUrl = relUrl.split("?")[0];
    }
    return relUrl;
  },
  /**
   * 写埋点数据
   * @param data
   * @param callback
   * @returns {Promise<void>}
   */
  async writePoint(data, callback){

    data.timestamp = new Date().getTime();
    data.uuid = KZ.GetUserUUid();
    data.user_id = KZ.GetUserId();
    data.union_id = KZ.GetUserUnionid();
    data.open_id = KZ.GetUserOpenId();
    data.env = KZ_CONFIG.NODE_ENV;

    let hideError = true;

    await axios.post('https://sp.kuaizaixuetang.com//h5-shop-point/lms', data, hideError);

    if(callback){
      callback();
    }
  },
  /**
   * 写页面访问埋点
   * @param page
   * @param productId
   * @param data
   * @param callback
   */
  writePageViewPoint(page, productId, data, callback){

    let t2 = "";
    let refer = this.GetReferrerPath();

    //延迟 200ms 写 PV，以起到如果跳转页面就不记 PV 的效果
    setTimeout(() => {
      KZ.writePoint({
        t1: "页面访问",
        t2: t2,
        page: page,
        product_id: productId || 0,
        refer: refer,
        ...data
      }, callback);
    }, 200);
  },
  /**
   * 写漏斗埋点
   * @param funnelName  漏斗名称
   * @param step    步骤名称
   * @param productId  商品 id
   * @param data
   * @param callback
   */
  writeFunnelPoint(funnelName, step, productId, data, callback){

    //延迟 200ms 写 PV，以起到如果跳转页面就不记 PV 的效果
    setTimeout(() => {
      KZ.writePoint({
        t1: "funnel",
        t2: funnelName,
        step: step,
        product_id: productId || 0,
        ...data
      }, callback);
    }, 200);
  },

  /**
   * 比较版本号
   * @param v1
   * @param v2
   * @returns {number} v1 > v2 返回 1， v1 = v2 返回 0，v1 < v2 返回 -1
   */
  compareVersion(v1, v2) {
    v1 = v1.split('.');
    v2 = v2.split('.');
    const len = Math.max(v1.length, v2.length);

    while (v1.length < len) {
      v1.push('0');
    }
    while (v2.length < len) {
      v2.push('0');
    }

    for (let i = 0; i < len; i++) {
      const num1 = parseInt(v1[i]);
      const num2 = parseInt(v2[i]);

      if (num1 > num2) {
        return 1;
      } else if (num1 < num2) {
        return -1;
      }
    }

    return 0;
  },
  /**
   * 检查app是否满足版本要求
   * @param supportIOSVersion 要求的IOS版本
   * @param supportAndroidVersion 要求的Android版本
   * @returns {boolean} 是app且版本满足条件返回true，否则返回false
   */
  appVersionSupport(supportIOSVersion, supportAndroidVersion) {
    let appSupport = false;
    if (KZ.IsIos()) {
      let version = KZ.GetHeaderVersion();
      if (KZ.compareVersion(version, supportIOSVersion) >= 0) {
        appSupport = true;
      }
    } else if (KZ.IsAndroid()) {
      let version = KZ.GetHeaderVersion();
      if (KZ.compareVersion(version, supportAndroidVersion) >= 0) {
        appSupport = true;
      }
    }
    return appSupport;
  },
  /**
   * 获取用户是否已同意隐私协议
   * @returns {number|number|*} 0-未同意，1-已同意
   */
  getIsAgreePrivacy() {
    if (this.IsIos() || this.IsAndroid()) {
      let appVersionSupport = KZ.appVersionSupport('2.1.5', '4.2');
      if (appVersionSupport) {
        let ret = this.CallNativeNotify("checkIsAgreePrivacyAgreement", {});
        if (typeof ret === 'string') {
          ret = JSON.parse(ret);
        }
        return ret['isAgreePrivacy'] * 1 || 0;
      }
    }
    return localStorage.getItem("isAgreePrivacy") * 1 || 0;
  },
  /**
   * 设置用户是否同意了用户协议
   * @param isAgree 0-未同意，1-已同意
   */
  setIsAgreePrivacy(isAgree = 0) {
    localStorage.setItem("isAgreePrivacy", isAgree + '');
    if (this.IsIos() || this.IsAndroid()) {
      let appVersionSupport = KZ.appVersionSupport('2.1.5', '4.2');
      if (appVersionSupport) {
        this.CallNativeNotify("checkIsAgreePrivacyAgreement", {isAgree: isAgree});
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/utils.js